export default __webpack_public_path__ + "static/media/hht2_ep10_speaking_03.223cc3e5.png";